import script from "./CardView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardView.vue?vue&type=script&setup=true&lang=js"

import "./CardView.vue?vue&type=style&index=0&id=c82a7378&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c82a7378"]])

export default __exports__